interface CommonStructure {
  h1: string
  key: string
  path: string
  title: string
  lastmod: string
  language: Language
  locale: Language
  metaDescription?: string
  breadcrumbs: TopicData[]
  images: Image[]
  gradeLevels: GradeLevel[]
  type: Type
}

export type ChangeFreq = 'always' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | 'never'

export interface Document {
  key?: string
  path: string
  language: Language
  hreflang: Language
  lastmod?: string
  changefreq?: ChangeFreq
  title?: string
  description?: string
  srcKey?: string
  thumbnail?: string
  uploadDate?: string
}

interface FileOnlyStructure {
  previewUrl: string
  smallPreviewUrl: string
  cssUrl: string
  htmlKey: string
}

export type FileStructure = CommonStructure & FileOnlyStructure

export type TopStructure = CommonStructure & { children: Structure[] }

export type Structure = TopStructure | FileStructure

export interface Image {
  alt?: string
  width?: number
  height?: number
  url: string
}

export interface TopicData {
  h1: string
  path: string
}

export enum Language {
  NO = 'no',
  EN = 'en',
  UA = 'uk',
}

export type GradeLevel =
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '1P'
  | '2P'
  | '1T'
  | 'S1'
  | 'S2'
  | 'R1'
  | 'R2'

export enum Type {
  GEOGEBRA = 'GeoGebra',
  EXCEL = 'Excel',
  ENCYCLOPEDIA = 'Encyclopedia',
  DRILL = 'drill',
}

export interface BootcampDataType {
  gymCategory: string
  language: Language
  key: string
  modules: Array<{
    moduleNumber: string
    hasWhyLevel: boolean
    whyName: string
    howContent: any
    encyclopediaArticle: string
    metaDescription: string
    pages: Array<{
      name: string
      level: string
      metaDescription: string
      howContent: any
      encyclopediaArticle: string
      activities: any[]
    }>
  }>
}

export interface VideoDetailsType {
  path: string
  language: string
  title: string
  description: string
  srcKey: string
  thumbnailUrl: string
  uploadDate: string
}
